module.exports = __webpack_public_path__ + "img/share-text.92f5ff25.svg";